import Typography, { type TypographyProps } from "@mui/material/Typography";

/** Small secondary text for annotations, footnotes, and inline asides. */
export function Caption(props: TypographyProps) {
  return <Typography variant="caption" color="text.secondary" {...props} />;
}
